import AgentPushBanner from './AgentPushBanner.component'

export default AgentPushBanner
